export enum XpressDisciplinaryHearingLocationsEnum {
    None = 0,
    XpressBrixton = 1,
    XpressUptown = 2,
    XpressAyala = 3
}
